// extracted by mini-css-extract-plugin
export default {"container":"ShareTooltip_container__Smzop","title":"ShareTooltip_title__EZS-h"};